import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.storageServiceUrl + '/cloud-storage/admin/applicationCredential/config/';

function baseApi() {

    function insertConfig(data) {
        return Post(baseUrl + 'insertConfig', data);
    }

    function updateConfig(data) {
        return Post(baseUrl + 'updateConfig', data);
    }

    function deleteConfig(data) {
        return Post(baseUrl + 'deleteConfig', data);
    }

    function queryList() {
        return Post(baseUrl + 'queryList', {});
    }

    function queryByAppId(data) {
        return Post(baseUrl + 'queryByAppId', data);
    }


    return {
        insertConfig, deleteConfig, updateConfig, queryList, queryByAppId
    };
}

export const applicationCredentialApi = baseApi();
